<template>
  <div>
    <v-row class="ma-0">
      <v-btn small>問{{ !$route.params.id ? Number(no) + 1 : Number(no) }}</v-btn>
    </v-row>
    <v-row class="mx-0 mt-2 lead-sentence">
      <span class>{{ formGeneral.leadSentence }}</span>
    </v-row>
    <v-stepper v-model="step">
      <v-stepper-items>
        <!-- Void data all -->
        <v-stepper-content step="1">
          <v-row class="mx-0 mt-5" justify="center">
            <audio
              class="ml-3"
              ref="audioTemplate"
              :key="`Template-${keyAudio}`"
              v-if="formGeneral.audio && formGeneral.audio.fileUrl"
            >
              <source :src="formGeneral.audio.fileUrl" type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
            <v-btn color="warning" fab x-large dark @click="play">
              <v-icon v-if="!formGeneral.audio">fas fa-volume-off</v-icon>
              <v-icon v-if="formGeneral.audio && formGeneral.audio.fileUrl"
                >fas fa-volume-up</v-icon
              >
            </v-btn>
          </v-row>
          <v-row align="end" class="min-height-1" justify="center">
            <v-btn
              class="font-weight-bold min-width-1"
              @click="step = 2"
              color="warning"
              small
              >{{ $t("NEXT") }}</v-btn
            >
          </v-row>
        </v-stepper-content>

        <!-- Void data question 1 -->
        <v-stepper-content step="2">
          <span class="font-weight-bold">1.</span>
          <v-row class="mx-0 mt-5" justify="center">
            <audio
              class="ml-3"
              ref="audioTemplate1"
              :key="`Template-${keyAudio}`"
              v-if="
                formGeneral.sub_question.question1.audio &&
                formGeneral.sub_question.question1.audio.fileUrl
              "
            >
              <source
                :src="formGeneral.sub_question.question1.audio.fileUrl"
                type="audio/mp3"
              />
              Your browser does not support the audio element.
            </audio>
            <v-btn color="warning" fab x-large dark @click="playAudio1">
              <v-icon v-if="!formGeneral.sub_question.question1.audio"
                >fas fa-volume-off</v-icon
              >
              <v-icon
                v-if="
                  formGeneral.sub_question.question1.audio &&
                  formGeneral.sub_question.question1.audio.fileUrl
                "
                >fas fa-volume-up</v-icon
              >
            </v-btn>
          </v-row>
          <v-row class="mx-0 mt-5">
            <v-col
              :cols="!checkLengthQuestion1 ? 6 : 12"
              v-for="(answers, index) in formGeneral.sub_question.question1
                .answers"
              :key="index"
            >
              <button class="width-10 pa-1 grey lighten-4 button-template">
                {{ answers.value ? answers.value : answers.name }}
              </button>
            </v-col>
          </v-row>
          <v-row align="end" justify="center">
            <v-btn
              class="font-weight-bold mt-5 min-width-1"
              @click="step = 3"
              color="warning"
              small
              >{{ $t("NEXT") }}</v-btn
            >
          </v-row>
        </v-stepper-content>

        <!-- Void data question 2 -->
        <v-stepper-content step="3">
          <span class="font-weight-bold">2.</span>
          <v-row class="mx-0 mt-5" justify="center">
            <audio
              class="ml-3"
              ref="audioTemplate2"
              :key="`Template-${keyAudio}`"
              v-if="
                formGeneral.sub_question.question2.audio &&
                formGeneral.sub_question.question2.audio.fileUrl
              "
            >
              <source
                :src="formGeneral.sub_question.question2.audio.fileUrl"
                type="audio/mp3"
              />
              Your browser does not support the audio element.
            </audio>

            <v-btn color="warning" fab x-large dark @click="playAudio2">
              <v-icon v-if="!formGeneral.sub_question.question2.audio"
                >fas fa-volume-off</v-icon
              >
              <v-icon
                v-if="
                  formGeneral.sub_question.question2.audio &&
                  formGeneral.sub_question.question2.audio.fileUrl
                "
                >fas fa-volume-up</v-icon
              >
            </v-btn>
          </v-row>
          <v-row class="mx-0 mt-5">
            <v-col
              :cols="!checkLengthQuestion2 ? 6 : 12"
              v-for="(answers, index) in formGeneral.sub_question.question2
                .answers"
              :key="index"
            >
              <button class="width-10 pa-1 grey lighten-4 button-template">
                {{ answers.value ? answers.value : answers.name }}
              </button>
            </v-col>
          </v-row>
          <v-row align="end" justify="center">
            <v-btn
              class="font-weight-bold mt-5 min-width-1"
              @click="step = 1"
              color="warning"
              small
            >
              <v-icon>fas fa-undo-alt</v-icon>
              {{ $t("LOOK_AGAIN") }}
            </v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
export default {
  props: ["no"],
  store: ["formGeneral"],
  data() {
    return {
      keyAudio: 0,
      step: 1,
      keyAudioQuestion1: 0,
      keyAudioQuestion2: 0,
    };
  },
  watch: {
    "formGeneral.audio": function () {
      this.keyAudio++;
    },
    "formGeneral.sub_question.question1.audio": function () {
      this.keyAudioQuestion1++;
    },
    "formGeneral.sub_question.question2.audio": function () {
      this.keyAudioQuestion2++;
    },
    step: function () {
      this.audioPlay = false;
      this.audioPlay1 = false;
      this.audioPlay2 = false;
      if (this.$refs.audioTemplate) {
        this.$refs.audioTemplate.pause();
      }
      if (this.$refs.audioTemplate1) {
        this.$refs.audioTemplate1.pause();
      }
      if (this.$refs.audioTemplate2) {
        this.$refs.audioTemplate2.pause();
      }
    },
  },
  computed: {
    checkLengthQuestion1() {
      return Boolean(
        this.formGeneral.sub_question.question1.answers.find(
          (e) => e.value.length > 9
        )
      );
    },
    checkLengthQuestion2() {
      return Boolean(
        this.formGeneral.sub_question.question2.answers.find(
          (e) => e.value.length > 9
        )
      );
    },
  },
  methods: {
    play() {
      if (this.$refs.audioTemplate.paused) {
        this.$refs.audioTemplate.play();
      } else {
        this.$refs.audioTemplate.pause();
      }
    },
    playAudio1() {
      if (this.$refs.audioTemplate1.paused) {
        this.$refs.audioTemplate1.play();
      } else {
        this.$refs.audioTemplate1.pause();
      }
    },
    playAudio2() {
      if (this.$refs.audioTemplate2.paused) {
        this.$refs.audioTemplate2.play();
      } else {
        this.$refs.audioTemplate2.pause();
      }
    },
  },
};
</script>
<style scoped>
.lead-sentence {
  white-space: pre-wrap;
  padding-bottom: 8px;
  border-bottom: 5px dotted #feb798;
}
::v-deep .v-stepper {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  -webkit-box-shadow: node;
  box-shadow: none;
}
button {
  word-wrap: break-word;
}
</style>